import { SelectOption } from '@components/shared/FormField'

export enum LevelAchievedValue { BELOW_F_PLATINUM, FOUNDERS_PLATINUM_TO_FOUNDERS_EMERALD, DIAMOND_AND_ABOVE }
export enum FqGrowthValue { DROP, MAINTAIN, FQS_1_TO_2, FQS_3_TO_5, FQS_6_PLUS }

export function frontlineGroupGrowthLevelAchievedOptions(): SelectOption<LevelAchievedValue>[] {

  const levelAchievedOptions: SelectOption<LevelAchievedValue>[] = [
    { label: 'BELOW_FOUNDERS_PLATINUM', value: LevelAchievedValue.BELOW_F_PLATINUM },
    { label: 'FOUNDERS_PLATINUM_TO_FOUNDERS_EMERALD', value: LevelAchievedValue.FOUNDERS_PLATINUM_TO_FOUNDERS_EMERALD },
    { label: 'DIAMOND_AND_ABOVE', value: LevelAchievedValue.DIAMOND_AND_ABOVE }
  ]

  return levelAchievedOptions
}

export function frontlineGroupGrowthFqGrowthOptions(): SelectOption<FqGrowthValue>[] {
  const fqGrowthOptions: SelectOption<FqGrowthValue>[] = [
    { label: 'DROP', value: FqGrowthValue.DROP },
    { label: 'MAINTAIN', value: FqGrowthValue.MAINTAIN },
    { label: 'FQS_1_TO_2', value: FqGrowthValue.FQS_1_TO_2 },
    { label: 'FQS_3_TO_5', value: FqGrowthValue.FQS_3_TO_5 },
    { label: 'FQS_6_PLUS', value: FqGrowthValue.FQS_6_PLUS }
  ]

  return fqGrowthOptions
}
